import React, { useState } from 'react';
import axios from 'axios';
import { Config } from '../.env.js';
import { useLocation, useNavigate } from 'react-router-dom';
import EditablePlaceholderInput from './editable.js';
import BankDetails from './bankDetails.js';
import "./style.css";
import Address from '../orderTemplateComponents/address.js';
import SocialQuestion from '../orderTemplateComponents/SocialQuestion.js';
import PersonalDetails from '../orderTemplateComponents/PersonalDetails.js';
import OrderDetails from '../orderTemplateComponents/orderDetails.js';


const ConformationForm = () => {
  const navigate = useNavigate();
  const [instagram, setInstagram] = useState(false);
  const [facebook, setFacebook] = useState(false);
  const [twitter, setTwitter] = useState(false);
  const [youTube, setYouTube] = useState(false);
  const [customSocial, setCustomSocial] = useState('');
  const [customMarketPlaceName, setCustomMarketPlaceName] = useState('');
  const [customForoum, setCustomForoum] = useState('');
  const [FullName, setFullName] = useState(false);
  const [review, setReview] = useState(''); // Initialize as an empty string
  const [gender, setGender] = useState(false);
  const [langaugeSpeek, setlangaugeSpeek] = useState(false);
  const [langaugeWrite, setlangaugeWrite] = useState(false);
  const [student, setStudent] = useState(false);
  const [productSS, setProductSS] = useState(false);
  const [order, setOrder] = useState(false);
  const [city, setCity] = useState(false);
  const [state, setState] = useState(false);
  const [pinCode, setPinCode] = useState(false);
  const [accountNumber, setaccountNumber] = useState(false);
  const [upi, setUpi] = useState(false);
  const [ifsc, setifsc] = useState(false);
  const [BeneficiaryName, setBeneficiaryName] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(false);
  const [BankName, setBankName] = useState(false);
  const [whatsappGroup, setWhatsappGroup] = useState(false);
  const [manager, setManager] = useState(false);
  const [Phone, setPhone] = useState(false);
  const [date, setDate] = useState(false);
  const [college, setCollege] = useState(false);
  const [whatsapp, setWhatsapp] = useState(false);
  const [email, setEmail] = useState(false);
  const [profileType, setprofileType] = useState('');
  const [submitedDate, setsubmitedDate] = useState('');
  const [products, setProducts] = useState([
    { name: '', quantity: '', ss: null, amount: '' }
  ]);
  const [inputValue, setInputValue] = useState('');
  const [inputValue1, setInputValue1] = useState('');
  const [inputValue2, setInputValue2] = useState('');
  const [deliveryCharge, setDeliveryCharge] = useState('');
  const [inputValue3, setInputValue3] = useState('');
  const [inputValue4, setInputValue4] = useState('');
  const [applyForReview, setApplyForReview] = useState(false);

  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const { campaignName, id, brandName } = location.state || {};
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      instagram,
      facebook,
      twitter,
      youTube,
      customMarketPlaceName,
      FullName,
      gender,
      langaugeWrite,
      langaugeSpeek,
      college,
      whatsapp,
      email,
      date,
      manager,
      whatsappGroup,
      pinCode,
      state,
      accountNumber,
      upi,
      ifsc,
      BeneficiaryName,
      BankName,
      productSS,
      inputValue,
      inputValue1,
      inputValue2,
      inputValue3,
      inputValue4,
      order,
      city,
      Phone,
      student,
      review,
      customForoum,
      customSocial,
      profileType,
      submitedDate,
      deliveryCharge,
      campaignName,
      brandName,
      id,
    };
    try {
      const response = await axios.post(`${Config.API_URL}/api/FormData/${id}`, formData);
      console.log('Form data submitted:', response.data);
      // navigate('/template-refund', { state: { campaignName } });
      // navigate('/template-refund', { state: { order, email, Phone, campaignName, id } });
      const role = localStorage.getItem("userRole");
      console.log("Role:", role);

      if (applyForReview) {
        // ✅ Role-based navigation
        if (role === "Admin") {
          navigate("/admin", { state: { campaignName, id, brandName } });
        } else if (role === "Lead") {
          navigate("/lead", { state: { campaignName, id, brandName } });
        } else if (role === "Campaign_Manger" || role === "Payment_Approver") {
          navigate("/approver", { state: { campaignName, id, brandName } });
        } else {
          navigate("/default-dashboard", { state: { campaignName, id, brandName } });
        }
      } else {
        // ✅ Default navigation
        navigate("/template-refund", {
          state: { order, email, Phone, campaignName, id, brandName },
        });
      }
    } catch (error) {
      console.error('Error submitting form data:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (index, event) => {
    const values = [...products];
    if (event.target.name === "ss") {
      values[index][event.target.name] = event.target.files[0];
    } else {
      values[index][event.target.name] = event.target.value;
    }
    setProducts(values);
  };
  const handleAddFields = () => {
    setProducts([...products, { name: '', quantity: '', ss: null, amount: '' }]);
  };

  const handleRemoveFields = index => {
    const values = [...products];
    values.splice(index, 1);
    setProducts(values);
  };
  return (
    <div className='container' style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
      <div className='container1'>
        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
        <figure className="image is-64x64">
          {/* <img src={logo} alt="Logo" /> */}
        </figure>
      </div>
      <form onSubmit={handleSubmit}>
        <h1 className='title has-text-centered mb-3'>Order Form Setup Form</h1>
        <p><strong>Campaign Name:</strong> {campaignName}</p>
        <SocialQuestion    //done tested
          instagram={instagram}
          onInstagramChange={setInstagram}
          facebook={facebook}
          onFacebookChange={setFacebook}
          twitter={twitter}
          onTwitterChange={setTwitter}
          youTube={youTube}
          onYoutubeChange={setYouTube}
          customSocial={customSocial}
          oncustomSocialChange={setCustomSocial}
          customMarketPlaceName={customMarketPlaceName}
          oncustomMarketPlaceNameChange={setCustomMarketPlaceName}
          customForoum={customForoum}
          oncustomForoumChange={setCustomForoum}
          fullName={FullName}
          onFullNameChange={setFullName}

        />

        <PersonalDetails //done tested
          whatsapp={whatsapp}
          onwhatsappChange={setWhatsapp}
          email={email}
          onemailChange={setEmail}
          Phone={Phone}
          OnPhoneChange={setPhone}
          gender={gender}
          onGenderChange={setGender}
          langaugeSpeek={langaugeSpeek}
          onlangaugeSpeekChange={setlangaugeSpeek}
          langaugeWrite={langaugeWrite}
          onlangaugeWriteChange={setlangaugeWrite}
          profileType={profileType}
          onProfileTypeChange={setprofileType}
        />
        <OrderDetails //done tested
          order={order}
          date={date}
          submitedDate={submitedDate}
          review={review}
          onorderChange={setOrder}
          onDateChange={setDate}
          onsubmitedDateChange={setsubmitedDate}
          onReviewChange={setReview}
        />

        <div className="field is-small">
          <label className="checkbox">
            <input
              type="checkbox"
              checked={student}
              onChange={(e) => setStudent(e.target.checked)}
            />
            Are you a Student?
          </label>
        </div>
        <div className="field is-small">
          <label className="checkbox">
            <input
              type="checkbox"
              checked={college}
              onChange={(e) => setCollege(e.target.checked)}
            />
            If yes, Your College Name
          </label>
        </div>
        <div className="field is-small">
          <label className="checkbox">
            <input
              type="checkbox"
              checked={manager}
              onChange={(e) => setManager(e.target.checked)}
            />
            Choose Your Manager
          </label>
        </div>
        <Address //done tested issue on state
          city={city}
          state={state}
          pinCode={pinCode}
          onCityChange={setCity}
          onStateChange={setState}
          onPincodeChnage={setPinCode}

        />
        <BankDetails //done tested
          accountNumber={accountNumber}
          upi={upi}
          ifsc={ifsc}
          BeneficiaryName={BeneficiaryName}
          paymentMethod={paymentMethod}
          BankName={BankName}
          onPaymentMethodChange={setPaymentMethod}
          onAccountNumberChange={setaccountNumber}
          onUpiChange={setUpi}
          onIfscChange={setifsc}
          onBeneficiaryNameChange={setBeneficiaryName}
          onBankNameChange={setBankName}
        />



        <div className="field is-small is-flex is-align-items-center">
          <label className="checkbox" style={{ marginRight: '10px' }}>
            <input
              type="checkbox"
              checked={productSS}
              onChange={(e) => setProductSS(e.target.checked)}
            />
            Choose
          </label>
          <div className="field" style={{ marginRight: "10px" }}>
            <label className="label" style={{ marginBottom: "0px" }}>Ordered Products/Reviewed Page/Post/Link</label>
            <input
              className="input is-small"
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder="Ordered Products/Reviewed Page/Post/Link"
              style={{
                width: '500px',          // 👈 wider field
                height: '40px',          // 👈 taller input
                fontSize: '16px',        // 👈 larger text
                marginLeft: '5px',
                marginRight: '5px',
              }}
            />
          </div>
          <span style={{ marginLeft: '10px', marginRight: '5px' }}>with</span>
          <EditablePlaceholderInput //done tetsted
            deliveryCharge={deliveryCharge}
            inputValue1={inputValue1}
            inputValue2={inputValue2}
            inputValue3={inputValue3}
            inputValue4={inputValue}
            onDeliveryChargeChange={setDeliveryCharge}
            onInputValue1Change={setInputValue1}
            onInputValue2Change={setInputValue2}
            onInputValue3Change={setInputValue3}
            onInputValueChange={setInputValue}
          />

          <span style={{ marginLeft: '10px', marginRight: '5px' }}>for each Ordered Products/Reviewed Page/Post/Link</span>
        </div>

        <div className="field is-small mt-3">
          <label className="checkbox">
            <input
              type="checkbox"
              checked={whatsappGroup}
              onChange={(e) => setWhatsappGroup(e.target.checked)}
            />
            Have you joined WhatsApp Group
          </label>
        </div>
        <div className="field is-small">
          <label className="checkbox">
            <input
              type="checkbox"
              required
            // checked={city}
            // onChange={(e) => setCity(e.target.checked)}
            />
            Agree to{' '}
            <a href="//hobo.video/terms-conditions-for-an-influencer" target="_blank" rel="noopener noreferrer">
              Terms and Conditions
            </a>
          </label>
        </div>
        <div className="field is-small">
          <label className="checkbox">
            <input
              type="checkbox"
              checked={applyForReview}
              onChange={(e) => setApplyForReview(e.target.checked)} // ✅ new handler
            />
            Apply for review form Submission
          </label>
        </div>
        <div className="field">
          <div className="control">
            <button className="button is-primary is-rounded is-fullwidth mt-5" type="submit">   {loading ? (
              <div className="loader"></div> // Loader
            ) : (
              'Submit'
            )}</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ConformationForm;
